
import React from "react";
import { Container } from "react-bootstrap";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  outerStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  fluid?: boolean;
  useFragment?: boolean;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = "",
  outerStyle,
  innerStyle,
  fluid = true,
  useFragment = true,
}) => {
  const defaultOuterStyle: React.CSSProperties = {
    backgroundColor: "#e9ecef",
    minHeight: "100vh",
    ...outerStyle,
  };

  const defaultInnerStyle: React.CSSProperties = {
    backgroundColor: "#fff",
    padding: "30px 12px 30px 12px",
    borderRadius: "10px",
    boxShadow: "0 0 15px rgba(0,0,0,0.1)",
    ...innerStyle,
  };

  const content = (
    <div
      className={`page-content px-4 ${className}`}
      style={defaultOuterStyle}
    >
      <Container fluid={fluid} style={defaultInnerStyle}>
        {children}
      </Container>
    </div>
  );

  if (useFragment) {
    return <>{content}</>;
  }

  return content;
};

export default PageContainer;

